<div>
  <button
    style="width: 100%; background-color: white"
    *showAuthed="true"
    type="button"
    class="btn btn-sm btn-outline-text-mute"
    (click)="showAlert ? openDiscussionImageAlert() : imageUploadModal.show()"
  >
    <div class="row add-image-icon">
      <div style="margin: auto">
        <i class="icofont icofont-camera action-word"></i>
        <span class="action-word"> Upload image </span>
      </div>
    </div>
    <!-- Content marker -->
    <ng-content></ng-content>
  </button>

  <!-- Upload-image-modal -->
  <image-upload-modal
    #imageUploadModal
    [hideFooter]="true"
    [targetObject]="targetObject"
    [targetType]="targetType"
    (emitImage)="saveImage($event)"
  >
  </image-upload-modal>
  <!-- Upload-image-modal -->
</div>
